import axios from "axios";
import { baseUrl } from "./url";
import { token } from "./url";

// Auth Apis right

export const login = async (data) => {
  return await axios.post(
    `${baseUrl}/admin/auth/login`,
    {
      email: data.values.email,
      password: data.values.password,
    },
    {
      headers: {
        "Content-Type": "application/json",
      },
    },
  );
};

export const sendOtp = async (data) => {
  const formData = new FormData();
  formData.append("email", data.values.otpEmail);

  return await axios.post(`${baseUrl}/api/admin/send-otp`, formData, {
    headers: {
      "Content-Type": "multipart/form-data",
    },
  });
};

export const verifyOtp = async (data) => {
  const formData = new FormData();
  formData.append("email", data.values.otpEmail);
  formData.append("otp", data.values.otp);

  return await axios.post(`${baseUrl}/api/admin/verify-otp`, formData, {
    headers: {
      "Content-Type": "multipart/form-data",
    },
  });
};

export const resetPassword = async (data) => {
  let formData = new FormData();

  formData.append("email", data.values.otpEmail);
  formData.append("newPassword", data.values.newPassword);
  formData.append("confirmNewPassword", data.values.confirmPassword);

  return await axios.post(`${baseUrl}/api/admin/reset-password`, formData, {
    headers: {
      "Content-Type": "application/json",
    },
  });
};

// Profile Apis

export const getProfile = () => {
  return axios.get(`${baseUrl}/api/admin/get`, {
    headers: {
      "Content-Type": "application/json",
      Authorization: `Bearer ${token}`,
    },
  });
};

export const updateProfile = async (profileData, adminProfileImage) => {
  const formData = new FormData();
  formData.append("firstName", profileData.firstName);
  formData.append("lastName", profileData.lastName);
  if (adminProfileImage) {
    formData.append("profileImage", adminProfileImage);
  }

  return await axios.patch(`${baseUrl}/api/admin/update`, formData, {
    headers: {
      "Content-Type": "multipart/form-data",
      Authorization: `Bearer ${token}`,
    },
  });
};

export const updatePassword = async (formData) => {
  return await axios.patch(`${baseUrl}/api/admin/change-password`, formData, {
    headers: {
      "Content-Type": "application/json",
      Authorization: `Bearer ${token}`, // Send the token here
    },
  });
};

//Users Management

export const getAdmin = async () => {
  return axios.get(`${baseUrl}/api/user/all`, {
    headers: {
      "Content-Type": "application/json",
      Authorization: `Bearer ${token}`, // Send the token here
    },
  });
};

// getUsers function moved to new location

export const createAdmin = async (formData) => {
  return axios.post(`${baseUrl}/api/auth/register-admin`, formData, {
    headers: {
      "Content-Type": "multipart/form-data",
      Authorization: `Bearer ${token}`, // Send the token here
    },
  });
};

export const deleteAdmin = async (id) => {
  return await axios.delete(`${baseUrl}/delete-by/${id}`, {
    headers: {
      Authorization: `Bearer ${token}`,
    },
  });
};

export const updateAdmin = async (id, active) => {
  return await axios.patch(
    `${baseUrl}/api/user/update/${id}?active=${active}`,
    {},
    {
      headers: {
        "Content-Type": "application/json",
        Authorization: `Bearer ${token}`, // Send the token here
      },
    },
  );
};

// admin Faq

export const getFaq = async () => {
  return await axios.get(`${baseUrl}/api/faqs/get/all`, {
    "Content-Type": "application/json",
  });
};

// employee Faq

export const getEmployeeFaq = async () => {
  return await axios.get(`${baseUrl}/api/faq/get-all`, {
    "Content-Type": "application/json",
  });
};

// Crud of Admin FAq

export const addFaq = async (formData) => {
  return await axios.post(`${baseUrl}/api/faqs/create`, formData, {
    headers: {
      "Content-Type": "application/json",
      // 'Authorization': `Bearer ${token}`, // Send the token here
    },
  });
};

export const updateFaq = async (id, formData) => {
  return await axios.put(`${baseUrl}/api/faqs/update/${id}`, formData, {
    headers: {
      "Content-Type": "application/json",
    },
  });
};

export const handleDeleteFaq = async (id) => {
  return await axios.delete(`${baseUrl}/api/faqs/delete/${id}`, {
    "Content-Type": "application/json",
  });
};

// Crud of Employee

export const addEmployeeFaq = async (formData) => {
  return await axios.post(`${baseUrl}/api/faq/create`, formData, {
    headers: {
      "Content-Type": "application/json",
    },
  });
};

export const updateEmployeeFaq = async (id, formData) => {
  return await axios.patch(`${baseUrl}/api/faq/update/${id}`, formData, {
    headers: {
      "Content-Type": "application/json",
    },
  });
};

export const deleteEmployeeFaq = async (id) => {
  return await axios.delete(`${baseUrl}/api/faq/delete/${id}`, {
    "Content-Type": "application/json",
  });
};

// About us

export const createAboutUs = async (formData) => {
  return await axios.post(`${baseUrl}/api/about-us/create`, formData, {
    headers: {
      "content-Type": "application/json",
      Authorization: `Bearer ${token}`,
    },
  });
};

export const updateAboutUs = async (id, formData) => {
  return await axios.put(`${baseUrl}/api/about-us/update/${id}`, formData, {
    headers: {
      "content-Type": "application/json",
      Authorization: `Bearer ${token}`,
    },
  });
};

export const getAboutUs = async () => {
  return await axios.get(`${baseUrl}/api/about-us/get/all`, {
    headers: {
      Authorization: `Bearer ${token}`,
    },
  });
};

// Terms and Conditions

export const getTermsAndConditions = async () => {
  return axios.get(`${baseUrl}/api/terms-and-conditions/get-all`, {
    headers: {
      Authorization: `Bearer ${token}`,
    },
  });
};

export const updateTermsAndConditions = async (id, formData) => {
  return await axios.patch(
    `${baseUrl}/api/terms-and-conditions/update/${id}`,
    formData,
    {
      headers: {
        "content-Type": "application/json",
        Authorization: `Bearer ${token}`,
      },
    },
  );
};

export const createTermsAndConditions = async (formData) => {
  return await axios.post(
    `${baseUrl}/api/terms-and-conditions/create`,
    formData,
    {
      headers: {
        "content-Type": "application/json",
        Authorization: `Bearer ${token}`,
      },
    },
  );
};

// privacy policies

export const getPrivacyPolicy = () => {
  return axios.get(`${baseUrl}/api/privacy-policy/get-all`, {
    headers: {
      Authorization: `Bearer ${token}`,
    },
  });
};

export const updatePrivacyPolicy = async (id, formData) => {
  return await axios.patch(
    `${baseUrl}/api/privacy-policy/update/${id}`,
    formData,
    {
      headers: {
        "content-Type": "application/json",
        Authorization: `Bearer ${token}`,
      },
    },
  );
};

export const createPrivacyPolicy = async (formData) => {
  return await axios.post(`${baseUrl}/api/privacy-policy/create`, formData, {
    headers: {
      "content-Type": "application/json",
      Authorization: `Bearer ${token}`,
    },
  });
};

// Clinics Management

export const getClinics = async () => {
  return await axios.get(`${baseUrl}/api/clinic/get-all`, {
    headers: {
      "content-Type": "application/json",
    },
  });
};

export const addClinic = async (data) => {
  return await axios.post(`${baseUrl}/api/clinic/create`, data, {
    headers: {
      "content-Type": "application/json",
      Authorization: `Bearer ${token}`,
    },
  });
};

export const deleteClinic = async (id) => {
  return await axios.delete(`${baseUrl}/api/clinic/delete/${id}`, {
    headers: {
      "content-Type": "application/json",
      Authorization: `Bearer ${token}`,
    },
  });
};

export const editClinic = async (id, data) => {
  return await axios.patch(`${baseUrl}/api/clinic/update/${id}`, data, {
    headers: {
      "content-Type": "application/json",
      Authorization: `Bearer ${token}`,
    },
  });
};

// Help and Support (Legacy - use getHelpRequests instead)

export const getHelpAndSuport = async () => {
  return getHelpRequests();
};

export const createSupportData = async (data) => {
  return await axios.post(`${baseUrl}/help`, data, {
    headers: {
      "content-Type": "application/json",
    },
  });
};

export const updateSupportData = async (id, data) => {
  // Note: Public help requests don't have update endpoint
  // This function is kept for backward compatibility but may not work
  console.warn("updateSupportData: Help requests cannot be updated publicly");
  return null;
};

// Cases Management

export const getCases = async (page, size) => {
  return axios.get(
    `${baseUrl}/api/case/get-all?pageNumber=${page}&pagseSize=${size}`,
    {
      headers: {
        "content-Type": "application/json",
      },
    },
  );
};

export const editCase = async (id, status) => {
  return axios.patch(
    `${baseUrl}/api/case/update-status/${id}?status=${status}`,
    {},
    {
      headers: {
        "Content-Type": "application/json",
        Authorization: `Bearer ${token}`,
      },
    },
  );
};

export const uploadReport = async (id, data) => {
  return await axios.post(`${baseUrl}/api/reports/upload/${id}`, data, {
    headers: {
      "Content-Type": "multipart/form-data",
      Authorization: `Bearer ${token}`,
    },
  });
};

export const getUploadedReports = async (id) => {
  return axios.get(`${baseUrl}/api/reports/case/${id}`, {
    headers: {
      "content-Type": "application/json",
    },
  });
};

export const getPdfData = async () => {
  return axios.get(`${baseUrl}/api/flipbook/get`, {
    headers: {
      "content-Type": "application/json",
    },
  });
};

export const updateFlipBookPdf = async (data, id) => {
  return await axios.put(`${baseUrl}/api/flipbook/update/${id}`, data, {
    headers: {
      "Content-Type": "multipart/form-data",
      Authorization: `Bearer ${token}`,
    },
  });
};

// Banner Management APIs

export const getBanners = async (type = null, isActive = null) => {
  let queryParams = [];
  if (type) queryParams.push(`type=${type}`);
  if (isActive !== null) queryParams.push(`isActive=${isActive}`);
  const queryString = queryParams.length > 0 ? `?${queryParams.join("&")}` : "";

  return await axios.get(`${baseUrl}/admin/banners${queryString}`, {
    headers: {
      "content-Type": "application/json",
      Authorization: `Bearer ${token}`,
    },
  });
};

export const uploadImage = async (file) => {
  const formData = new FormData();
  formData.append("image", file);

  return await axios.post(`${baseUrl}/upload/image`, formData, {
    headers: {
      "Content-Type": "multipart/form-data",
      Authorization: `Bearer ${token}`,
    },
  });
};

export const register = async (data) => {
  return await axios.post(`${baseUrl}/auth/register`, data, {
    headers: {
      "Content-Type": "application/json",
    },
  });
};

export const createBanner = async (formData) => {
  return await axios.post(`${baseUrl}/admin/banners`, formData, {
    headers: {
      "content-Type": "multipart/form-data",
      Authorization: `Bearer ${token}`,
    },
  });
};

export const updateBanner = async (id, data) => {
  // Check if data is FormData to set appropriate headers
  const isFormData = data instanceof FormData;

  return await axios.patch(`${baseUrl}/admin/banners/${id}`, data, {
    headers: {
      "Content-Type": isFormData ? "multipart/form-data" : "application/json",
      Authorization: `Bearer ${token}`,
    },
  });
};

export const deleteBanner = async (id) => {
  return await axios.delete(`${baseUrl}/admin/banners/${id}`, {
    headers: {
      "content-Type": "application/json",
      Authorization: `Bearer ${token}`,
    },
  });
};

export const getActiveBanners = async (type = null) => {
  const queryString = type ? `?type=${type}` : "";

  return await axios.get(`${baseUrl}/admin/banners/active${queryString}`, {
    headers: {
      "content-Type": "application/json",
      Authorization: `Bearer ${token}`,
    },
  });
};

// Content Management APIs

export const getContents = async (includeUnpublished = null) => {
  const queryString =
    includeUnpublished !== null
      ? `?includeUnpublished=${includeUnpublished}`
      : "";

  return await axios.get(`${baseUrl}/admin/contents${queryString}`, {
    headers: {
      "content-Type": "application/json",
      Authorization: `Bearer ${token}`,
    },
  });
};

export const createContent = async (data) => {
  return await axios.post(`${baseUrl}/admin/contents`, data, {
    headers: {
      "content-Type": "application/json",
      Authorization: `Bearer ${token}`,
    },
  });
};

export const getContentById = async (id, includeUnpublished = null) => {
  const queryString =
    includeUnpublished !== null
      ? `?includeUnpublished=${includeUnpublished}`
      : "";

  return await axios.get(`${baseUrl}/admin/contents/${id}${queryString}`, {
    headers: {
      "content-Type": "application/json",
      Authorization: `Bearer ${token}`,
    },
  });
};

export const updateContent = async (id, data) => {
  return await axios.put(`${baseUrl}/admin/contents/${id}`, data, {
    headers: {
      "content-Type": "application/json",
      Authorization: `Bearer ${token}`,
    },
  });
};

export const deleteContent = async (id) => {
  return await axios.delete(`${baseUrl}/admin/contents/${id}`, {
    headers: {
      "content-Type": "application/json",
      Authorization: `Bearer ${token}`,
    },
  });
};

export const getContentBySlug = async (slug) => {
  return await axios.get(`${baseUrl}/admin/contents/slug/${slug}`, {
    headers: {
      "content-Type": "application/json",
      Authorization: `Bearer ${token}`,
    },
  });
};

export const getContentsByType = async (type, includeUnpublished = null) => {
  const queryString =
    includeUnpublished !== null
      ? `?includeUnpublished=${includeUnpublished}`
      : "";

  return await axios.get(
    `${baseUrl}/admin/contents/type/${type}${queryString}`,
    {
      headers: {
        "content-Type": "application/json",
        Authorization: `Bearer ${token}`,
      },
    },
  );
};

// Story Management APIs

export const getStories = async () => {
  return await axios.get(`${baseUrl}/admin/stories`, {
    headers: {
      "content-Type": "application/json",
      Authorization: `Bearer ${token}`,
    },
  });
};

export const getStoryById = async (id) => {
  return await axios.get(`${baseUrl}/admin/stories/${id}`, {
    headers: {
      "content-Type": "application/json",
      Authorization: `Bearer ${token}`,
    },
  });
};

export const updateStory = async (id, data) => {
  return await axios.put(`${baseUrl}/admin/stories/${id}`, data, {
    headers: {
      "content-Type": "application/json",
      Authorization: `Bearer ${token}`,
    },
  });
};

export const deleteStory = async (id) => {
  return await axios.delete(`${baseUrl}/admin/stories/${id}`, {
    headers: {
      "content-Type": "application/json",
      Authorization: `Bearer ${token}`,
    },
  });
};

export const getStoriesByUser = async (userId) => {
  return await axios.get(`${baseUrl}/admin/stories/user/${userId}`, {
    headers: {
      "content-Type": "application/json",
      Authorization: `Bearer ${token}`,
    },
  });
};

// User Management APIs

export const getUsers = async () => {
  return await axios.get(`${baseUrl}/admin/users`, {
    headers: {
      "content-Type": "application/json",
      Authorization: `Bearer ${token}`,
    },
  });
};

export const getUserById = async (id) => {
  return await axios.get(`${baseUrl}/admin/users/${id}`, {
    headers: {
      "content-Type": "application/json",
      Authorization: `Bearer ${token}`,
    },
  });
};

export const updateUser = async (id, data) => {
  return await axios.put(`${baseUrl}/admin/users/${id}`, data, {
    headers: {
      "content-Type": "application/json",
      Authorization: `Bearer ${token}`,
    },
  });
};

export const deleteUser = async (id) => {
  return await axios.delete(`${baseUrl}/admin/users/${id}`, {
    headers: {
      "content-Type": "application/json",
      Authorization: `Bearer ${token}`,
    },
  });
};

export const updateUserAdminStatus = async (id, isAdmin) => {
  return await axios.put(
    `${baseUrl}/admin/users/${id}/admin-status`,
    { isAdmin },
    {
      headers: {
        "content-Type": "application/json",
        Authorization: `Bearer ${token}`,
      },
    },
  );
};

// Subscription Management APIs

export const getSubscriptionPlans = async (isActive = null) => {
  const queryString = isActive !== null ? `?isActive=${isActive}` : "";

  return await axios.get(`${baseUrl}/admin/subscriptions/plans${queryString}`, {
    headers: {
      "content-Type": "application/json",
      Authorization: `Bearer ${token}`,
    },
  });
};

export const createSubscriptionPlan = async (data) => {
  return await axios.post(`${baseUrl}/admin/subscriptions/plans`, data, {
    headers: {
      "content-Type": "application/json",
      Authorization: `Bearer ${token}`,
    },
  });
};

export const updateSubscriptionPlan = async (id, data) => {
  return await axios.put(`${baseUrl}/admin/subscriptions/plans/${id}`, data, {
    headers: {
      "content-Type": "application/json",
      Authorization: `Bearer ${token}`,
    },
  });
};

export const deleteSubscriptionPlan = async (id) => {
  return await axios.delete(`${baseUrl}/admin/subscriptions/plans/${id}`, {
    headers: {
      "content-Type": "application/json",
      Authorization: `Bearer ${token}`,
    },
  });
};

export const getSubscriptions = async () => {
  return await axios.get(`${baseUrl}/admin/subscriptions`, {
    headers: {
      "content-Type": "application/json",
      Authorization: `Bearer ${token}`,
    },
  });
};

// Dashboard APIs

export const getDashboardStats = async () => {
  return await axios.get(`${baseUrl}/admin/dashboard/stats`, {
    headers: {
      "content-Type": "application/json",
      Authorization: `Bearer ${token}`,
    },
  });
};

export const getDashboardActivities = async (limit = 10) => {
  return await axios.get(
    `${baseUrl}/admin/dashboard/activities?limit=${limit}`,
    {
      headers: {
        "content-Type": "application/json",
        Authorization: `Bearer ${token}`,
      },
    },
  );
};

// Help & Support APIs

export const getHelpRequests = async () => {
  return await axios.get(`${baseUrl}/admin/help`, {
    headers: {
      "content-Type": "application/json",
      Authorization: `Bearer ${token}`,
    },
  });
};

export const getHelpRequestById = async (id) => {
  return await axios.get(`${baseUrl}/admin/help/${id}`, {
    headers: {
      "content-Type": "application/json",
      Authorization: `Bearer ${token}`,
    },
  });
};

export const deleteHelpRequest = async (id) => {
  return await axios.delete(`${baseUrl}/admin/help/${id}`, {
    headers: {
      "content-Type": "application/json",
      Authorization: `Bearer ${token}`,
    },
  });
};

export const getHelpStats = async () => {
  return await axios.get(`${baseUrl}/admin/help/stats`, {
    headers: {
      "content-Type": "application/json",
      Authorization: `Bearer ${token}`,
    },
  });
};

// Public APIs (no authentication required)

export const getPublicBanners = async (type = null) => {
  const queryString = type ? `?type=${type}` : "";

  return await axios.get(`${baseUrl}/banners${queryString}`, {
    headers: {
      "content-Type": "application/json",
    },
  });
};

export const getPublicContents = async (includeUnpublished = null) => {
  const queryString =
    includeUnpublished !== null
      ? `?includeUnpublished=${includeUnpublished}`
      : "";

  return await axios.get(`${baseUrl}/contents${queryString}`, {
    headers: {
      "content-Type": "application/json",
    },
  });
};

export const getPublicContentBySlug = async (slug) => {
  return await axios.get(`${baseUrl}/contents/${slug}`, {
    headers: {
      "content-Type": "application/json",
    },
  });
};

export const getPublicContentsByType = async (type) => {
  return await axios.get(`${baseUrl}/contents/type/${type}`, {
    headers: {
      "content-Type": "application/json",
    },
  });
};

export const getDictionaryWord = async (word) => {
  return await axios.get(`${baseUrl}/dictionary/${word}`, {
    headers: {
      "content-Type": "application/json",
    },
  });
};

// Public user deletion (no authentication required)
export const deleteUserByEmail = async (email) => {
  return await axios.delete(`${baseUrl}/users/delete?email=${email}`, {
    headers: {
      "content-Type": "application/json",
    },
  });
};
